import { withSearch } from "@elastic/react-search-ui";
import type {
  FilterType,
  FilterValue,
  SearchResult,
  SortOption
} from "@elastic/search-ui";
import { Tag } from "components/common";
import { processText } from "components/search/buckets/utils";
import { useStoreContext } from "context/StoreProvider";
import { useLayoutEffect } from "react";
import { Table } from "react-bootstrap";
//import { isMobile } from 'react-device-detect'
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRaw } from "utils";

import { TableWrapper } from "./style";

type SmallLabResultViewProps = {
  results: SearchResult;
  setSearchTerm: (value: string) => void;
  searchTerm: string;
  setSort: (sort: SortOption[] | string, sortDirection?: string) => void;
  sortField: string;
  addFilter: (field: string, value: FilterValue[], type: FilterType) => void;
};

const SmallLabResultView = ({
  results,
  setSearchTerm,
  searchTerm,
  setSort,
  sortField,
  addFilter
}: SmallLabResultViewProps) => {
  const { state, actions } = useStoreContext();
  const { t } = useTranslation();

  const { codeSystem, showInactiveOnLoad } = state;
  const { updateShowInactiveOnLoad } = actions;

  const handleClickReplacedByCode = (replacedByCode: string) => {
    setSearchTerm(replacedByCode);
    addFilter("active", ["true", "false"], "any");
  };
  useLayoutEffect(() => {
    if (!sortField) {
      setSort([{ field: "code", direction: "asc" }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (showInactiveOnLoad) {
      addFilter("active", ["false", "true"], "any");
      updateShowInactiveOnLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*const headerHeight = document.querySelector('#site-header')?.clientHeight || 0 - not sure what this was for (might be pre css cleanup)
	const tabNavHeight =
		document.querySelector('#codesystem-tab-nav')?.clientHeight || 0
	const searchWrapperHeight =
		document.querySelector('#search-wrapper')?.clientHeight || 0
	const resultMetaBarHeight =
		document.querySelector('#result-meta')?.clientHeight || 0

	const calculateHeight = headerHeight + tabNavHeight + searchWrapperHeight + resultMetaBarHeight + 3

	const tableHeaderHeightCondition = isMobile || window.innerWidth < 992 ? 0 : calculateHeight*/

  return (
    <TableWrapper>
      <Table responsive="md" id={`${codeSystem}-table`}>
        <thead>
          <tr>
            <th
              style={{
                top: 0
              }}
            >
              {t("general.codeValue")}
            </th>
            <th
              style={{
                top: 0
              }}
            >
              {t("general.codeText")}
            </th>
            <th
              style={{
                top: 0
              }}
            >
              {t("general.replacedBy")}
            </th>
            <th
              style={{
                top: 0
              }}
            >
              {t("general.validFrom")}
            </th>
            <th
              style={{
                top: 0
              }}
            >
              {t("general.validTo")}
            </th>
            <th
              style={{
                top: 0
              }}
            >
              {t("general.status")}
            </th>
          </tr>
        </thead>
        <tbody>
          {results.map((result: SearchResult) => {
            if (
              result.code.raw === "8351" ||
              result.code.raw === "8352" ||
              result.code.raw === "8340" ||
              result.code.raw === "8354"
            )
              return null;
            return (
              <tr key={getRaw(result, "code")} id={getRaw(result, "code")}>
                <td id={`${getRaw(result, "code")}-col`}>
                  {processText("code", searchTerm, false, result)}
                </td>
                <td id={`${getRaw(result, "name_norwegian")}-col`}>
                  {processText("name_norwegian", searchTerm, false, result)}
                </td>
                <td id={`${getRaw(result, "replaced_by")}-col`}>
                  {getRaw(result, "replaced_by") && (
                    <Link
                      onClick={() =>
                        handleClickReplacedByCode(
                          getRaw(result, "replaced_by") as string
                        )
                      }
                      to={`#`}
                    >
                      {processText("replaced_by", searchTerm, false, result)}
                    </Link>
                  )}
                </td>
                <td id={`${getRaw(result, "valid_from")}-col`}>
                  {processText("valid_from", searchTerm, false, result)}
                </td>
                <td id={`${getRaw(result, "valid_to")}-col`}>
                  {processText("valid_to", searchTerm, false, result)}
                </td>
                <td
                  id={`${getRaw(result, "active")}-${getRaw(
                    result,
                    "code"
                  )}-col`}
                >
                  <Tag
                    color={
                      getRaw(result, "active") === "true" ? "green" : "red"
                    }
                    text={
                      getRaw(result, "active") === "true"
                        ? t("general.active")
                        : t("general.inactive")
                    }
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

export default withSearch(
  ({ results, setSearchTerm, searchTerm, setSort, sortField, addFilter }) => ({
    results,
    setSearchTerm,
    searchTerm,
    setSort,
    sortField,
    addFilter
  })
)(SmallLabResultView);
